<template>
    <section class="">
        <front-table :front_page="page"
                     :front_records="records"
                     :front_search="search"
                     :front_header="header"
                     :model="model"
                     @reload="handleReload"
                     @edit="handleEdit"
                     :btn_copy = "can_copy"
                     @copy="handleCopy"
        >
            <div class="pull-right d-flex" style="padding-top: 2px;">
                <one-file-upload :upload-url="modelImportUrl" @reload="handleReload">
                    <el-button size="medium" type="success" class="mr-2"
                               icon="el-icon-upload2">{{('导入Excel')}}
                    </el-button>
                </one-file-upload>
                <el-button size="medium" @click="goDownload" type="danger"
                           icon="el-icon-download">{{('下载样本')}}
                </el-button>
            </div>
        </front-table>
        <!--编辑界面-->
        <edit-dialog :edit_mode="edit_mode" :model="model" :single="single" :fields="fields" dual
                     @success="handleSuccess" @cancel="handleCancel"></edit-dialog>

        <div class="clearfix"></div>
    </section>
</template>

<script>
    import EditDialog from "../components/edit-dialog";
    import FrontTable from "../components/front-table";
    import FrontMixins from "../common/mixins/front-mixins";
    import OneFileUpload from "../components/common-file-upload";

    export default {
        mixins: [FrontMixins],
        name: 'admin-admin',
        components: {FrontTable, EditDialog,OneFileUpload},
        created() {
            this.model =  'Admin.' + this.$route.meta.model;
        },
        computed:{
            can_copy(){
                return this.$route.meta?this.$route.meta.copy:false;
            },
            modelImportUrl() {
                return this.$apiUrl(this.model + '.Import');
            }
        },
        methods:{
            goImport(){

            },
            goDownload(){
                window.open('/assets/address_template.xlsx');
            },
        }
    }

</script>

<style lang="scss">

</style>
